import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

import { resumeSubscription } from 'actions/billing'

class ResumeSubscriptionItem extends React.Component {
  render () {
    const { billingSubscription } = this.props
    if (billingSubscription.status !== 'paused') return null

    return (
      <Menu.Item onClick={() => this.props.resume(billingSubscription.id)} title="Resume">
        <Icon name="play"/>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  resume: (id) => dispatch(resumeSubscription(id))
})

export default connect(null, mapDispatchToProps)(ResumeSubscriptionItem)
